
<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="demobox banner">
      <el-carousel :interval="8000" trigger="click" class="bannerMain">
        <el-carousel-item v-for="item in banners" :key="item.key" >
          <div class="bannerimg" @click="bannersClick(item)" :class="{xauntin:item.key==2?true:false}">
            <img :src="item.imgSrc" class="bannerimg" alt="" />
            <!-- <a v-if="item.to" :href="item.url" target="_blank"></a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="xian"></div>
    <div class="demobox info">
        <img src="@/common/images/stockUniverse/27007.png" alt="">
        <img src="@/common/images/stockUniverse/27006.png" class="img1" alt="" @click="imgClick">
        <img src="@/common/images/stockUniverse/27004.png" class="img2" alt="" @click="imgClick">
    </div>
    <BottomsStockUniverse></BottomsStockUniverse>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";
import BottomsStockUniverse from "../sub/BottomsStockUniverse";
export default {
  name: "stockUniverse",
  components: { topNav, Bottoms,BottomsStockUniverse },
  data() {
    return {
      info: {
        info1: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "三大指数走势分化  东数西算再度井喷",
          text: "指数今日有所分化，主板指数震荡回升，创业板指弱势震荡。盘面上，题材板块轮番活跃。“东数西算”概念股继续强势，板块再掀涨停潮，依米康、首都在线、亚康股份、南凌科技等亚康股份、南凌科技等",
        },
        info2: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
        info3: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
        info4: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
      },
      party: {
        info1: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "同心抗疫 | 奉献社会爱心 助力抗击疫情",
          text: "献出一份爱心，收获无数温暖。临近年关，深圳再次拉响疫情防控警报，深圳各区紧急开展各项工作，为坚决抑制疫情蔓延势头，防止疫情外溢，全市各个街道社区开设核酸检测点，广大医务工作者和爱心支援者日夜奋战在一线，广大人民广大人民广大人民",
        },
        info2: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title:
            "党史学习丨习近平：继续把党史总结学习教育宣传引向深入 更好把握和运用党的百年奋斗历更好把握和运用党的百年奋斗历",
        },
        info3: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title:
            "党史学习丨习近平：继续把党史总结学习教育宣传引向深入 更好把握和运用党的百年奋斗历更好把握和运用党的百年奋斗历",
        },
      },
      cateList: [{}, {}],
      infolist1: [],
      infolist2: [],
      partys: [],
      banners: [
        {
          imgSrc: require("@/common/images/stockUniverse/26825@2x.png"),
          key: 1,
          to: true,
          url: "https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1",
        },
        {
          imgSrc: require("@/common/images/stockUniverse/26827.png"),
          key: 2,
          to: false,
          url: "",
        },
        {
          imgSrc: require("@/common/images/stockUniverse/26825.png"),
          key: 3,
          to: false,
          url: "",
        },
      ],
      //按钮变幻
      buttons: {
        b1: false,
        b2: false,
        b3: false,
        b4: false,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getInfo();
  },
  methods: {
    getInfo: function () {
      var that = this;
      //实时资讯
      this.$api.cate_list().then((res) => {
        if (res.code == 0) {
          res.data.list == null ? "" : (this.cateList = res.data.list);
          this.infolist1 = [];
          this.infolist2 = [];
          this.cateList.map(function (item, index) {
            that.$api.information_list(item.id).then((res1) => {
              if (res1.code == 0 && index == 0) {
                // console.log(item.id, res1.data);
                that.infolist1 = res1.data.list.slice(0, 1);
              }
              if (res1.code == 0 && index == 1) {
                // console.log(item.id, res1.data);
                that.infolist2 = res1.data.list.slice(0, 3);
                // console.log(that.infolist2);
              }
            });
          });
          // console.log(that.infolist1, that.infolist2);
        }
      });
      //党建专栏
      this.$api.party_list().then((res) => {
        if (res.code == 0) {
          res.data.list == null
            ? ""
            : (this.partys = res.data.list.slice(0, 3));
          this.partys.map(function (item, index) {
            if (index != 0) {
              item.class0 = "partymin";
            } else {
              item.class0 = "partymin";
            }
            item.class1 = "party" + (index + 4);
          });
          console.log(this.partys);
        }
      });
    },
    bufnc(ev) {
      var ev = ev || window.event;
      var target = ev.target || ev.srcElement;
      var boll = target.classList[1];
      var name = target.classList[2];
      //console.log(target.classList);
      console.log(ev);

      var tname = target.nodeName.toLowerCase();
      console.log(boll, name, tname);
      if (tname == "div" || tname == "span" || tname == "img") {
        if (boll == "ins") {
          this.buttons[name] = true;
        } else {
          this.buttons[name] = false;
        }
      }
      console.log(this.buttons[name], name);
    },
    topath(path) {
      this.$router.push(path);
    },
    toDetail(data, name) {
      if (name == undefined) {
        window.open(data.html);
      } else {
        // console.log(data);
        this.$router.push(name + "?id=" + data.id);
      }
    },
    bannersClick(item){
    //   if(item.key == 2){
    //   }
    //   console.log(item);
    },
    imgClick(){ //点击下载
        window.open('https://dexun-install-new.oss-cn-shenzhen.aliyuncs.com/guyuzhou.exe');
        
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .index {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
}
 */

/* body * {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  filter: gray;
} 
.topNav {
  top: -90px !important;
}*/
.index{
  overflow: hidden;
}
.all .title {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 24px;
}
.all .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.all .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.all .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
/* -- */
.demobox {
  width: 100%;
  overflow: hidden;
}
.productCenter {
  display: block;
  width: 1920px;
  height: 742px;
  margin: 0 auto;
}
.boxin {
  width: 1226px;
  overflow: hidden;
  margin: 0 auto;
}
.xian{
  width: 100%;
  max-width: 1920px;
  margin: auto;
  height: 40px;
  background-color: #F4F4F4;
}
.banner {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 460px;
  margin: 0px auto;
  background: #ccc;
}
.bannerMain {
  width: 100%;
  height: 100%;
}
.xauntin:hover{
  cursor: pointer;
}

.bannerimg {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 460px;
  position: relative;
}
.bannerimg img {
  display: block;
  width: 1920px;
}
.bannerimg a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.licons-boxin {
  width: 1226px;
  margin: 0 auto;
}
.liconin {
  width: 1500px;
  height: 157px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.licons .cons {
  padding-right: 30px;
  overflow: hidden;
}
.licons .line {
  width: 30px;
  height: 59px;
  margin-top: 21px;
  opacity: 1;
  border-left: 1px solid #dbdbdb;
}

.licons .cons img {
  display: inline-block;
  margin-right: 20px;
  float: left;
}
.licons .cons div {
  float: left;
}
.licons .cons .p1 {
  height: 40px;
  font-size: 28px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  text-align: left;
}
.licons .cons .p2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #505050;
  line-height: 22px;
  margin-top: 8px;
  text-align: left;
}
.info {
    /* height: 822px; */
    width: 1920px;
    height: 1212px;
    /* background: url(../common/images/index/jc.png); */
    position: relative;
    margin: auto;
    overflow: hidden;
}
.img1{
    width: 434px;
    height: 142px;
    position: absolute;
    top: 29%;
    left: 19%;
}
.img2{
    width: 434px;
    height: 142px;
    position: absolute;
    top: 80%;
    left: 59%;
}
.img1:hover{
    cursor: pointer;
}
.img2:hover{
    cursor: pointer;
}
.info .infoMain {
  width: 100%;
  /* display: flex; */
  justify-content: left;
}
.info .infoMain-l,
.info .infoMain-r {
  /* background: #505050;
  min-height: 100px;
  min-width: 200px; */
}
.info .infoMain-l {
  width: 576px;
  margin-right: 34px;
}
.infoMain-box {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.infoMain-box img {
  width: 344px;
  height: 194px;
}
.infoMain-box .infoMain-font {
  text-align: left;
  width: 577px;
  margin-left: 20px;
  position: relative;
}
.infoMain-box .infoMain-title {
  /* height: 37px; */
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #222222;
  /* line-height: 37px; */
  text-align: left;
  margin-bottom: 10px;
}
.infoMain-box .infoMain-brief {
  font-size: 18px;
  /* height: 140px; */
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.infoMain-box .infoMain-foot {
  display: flex;
  align-items: center;
  color: #666666;
  position: absolute;
  bottom: 0;
  font-size: 16px;
}
.infoMain-box .infoMain-foot div:nth-child(2) {
  display: flex;
  align-items: center;
  margin-left: 90px;
}
.infoMain-box .infoMain-foot img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.infoMain-box:hover .infoMain-title {
  color: #DE161E;
  cursor: pointer;
}
.infoMain-box:hover{
  cursor: pointer;
}
.info .infoT {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
}
.info .infoT b {
  width: 4px;
  height: 20px;
  background: #e7413b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.info .infoT p {
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 11px;
}

.info .infoM {
  width: 576px;
  margin-top: 12px;
}
.info .infoBox {
  width: 100%;
  height: 100%;
  height: 343px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.info .infoM .timebox {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 205px;
  height: 46px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 8px 0px 8px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.info .infoM .timebox img {
  margin: 0 8px 0 18px;
}
.info .infoM .timebox span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}
.info .infort .p1 {
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 37px;
  text-align: left;
  margin: 16px 0 12px 0;
}
.info .infort .p2 {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.info .infort {
  cursor: pointer;
}
.info .infort:hover .p1 {
  color: #e7413b;
}
.info .infoMr {
  overflow: hidden;
  margin-top: 12px;
}
.infoMr .infoMrm {
  overflow: hidden;
  margin-bottom: 16px;
}
.infoMr .infoMrimg {
  display: block;
  float: left;
  width: 271px;
  height: 161px;
}
.infoMr .pr {
  width: 320px;
  height: 161px;
  float: left;
  margin-left: 16px;
  cursor: pointer;
}

.infoMr .pr .pr1 {
  height: 126px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 35px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.infoMr .pr .pr2 {
  height: 25px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.infoMr .pr:hover .pr1 {
  color: #e7413b;
}
.infoMr .pr .pr2 img {
  margin-right: 10px;
}
.infoMr .pr .pr2 span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}
.toinfoDetail {
  width: 172px;
  height: 48px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  margin-top: 14px;
}
.toinfoDetail span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}
.product {
  /* height: 575px; */
  overflow: hidden;
}
.product .title {
  margin-top: 60px;
  margin-bottom: 30px;
}
.products {
  width: 1279px;
  overflow: hidden;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-left: -8px;
}

.product .productT {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
}
.product .productT b {
  width: 4px;
  height: 20px;
  background: #e7413b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.product .productT p {
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 11px;
}
.productM {
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  margin-top: 10px;
  text-align: left;
}

.productButton {
  width: 172px;
  height: 48px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  /* background: url("../common/images/index/button.png"); */
  cursor: pointer;
  margin-top: 14px;
}
.productButton span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}
.investment {
  overflow: hidden;
}
.investment .title {
  margin-top: 70px;
  margin-bottom: 30px;
}
.investmentBanner {
  display: block;
  width: 1920px;
  height: 580px;
  margin: 0 auto;
}
.investmentText {
  width: 100%;
  height: 179px;
  overflow: hidden;
  background: #f4f4f4;
}
.investmentText .p {
  width: 1289px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: left;
}
.toinvestmentDetail {
  width: 172px;
  height: 48px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin: 0 auto;
  margin-top: 16px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.toinvestmentDetail span {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}

.party {
  overflow: hidden;
  height: 887px;
}
.party .boxin {
  width: 1226px;
}
.party .title {
  margin-top: 60px;
  margin-bottom: 30px;
}
.party .party1 {
  width: 100%;
}
.party1 .imgbox {
  width: 100%;
  height: 560px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.party1 .time {
  width: 199px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 4px 0px 4px;
  position: absolute;
  left: 0;
  bottom: 0;
  line-height: 40px;
  text-align: center;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.party1 .ptitle {
  font-size: 28px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  text-align: left;
  margin-top: 14px;
}
.party1 .ptext {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 35px;
  text-align: left;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.ptext {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.partymin {
  display: inline-block;
  width: 585px;
  float: left;
  margin-top: 5px;
  margin-bottom: 40px;
}
.party2 {
  margin-right: 18px;
}
.party3 {
  margin-left: 18px;
}
.party4 {
  margin-right: 56px;
}
.partymin .imgbox {
  width: 100%;
  height: 390px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.partymin .time {
  width: 199px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 4px 0px 4px;
  position: absolute;
  left: 0;
  bottom: 0;
  line-height: 40px;
  text-align: center;

  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.partymin .ptitle {
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 33px;
  text-align: left;
  margin-top: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.toPartyDetail {
  width: 172px;
  height: 48px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin: 0 auto;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.toPartyDetail span {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}
.party .ptitle,
.party .partyte {
  cursor: pointer;
}

.party .partyte {
  text-align: left;
}
.party .ptitle:hover {
  color: #e7413b;
}
.party .partyte:hover .ptitle {
  color: #e7413b;
}

/*  */
.btn {
  position: relative;
}
.btn .zwtz {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.btnBefore {
  background: #fcfcfc;
  border: 1px solid #bbbbbb;
  border-radius: 6px 6px 6px 6px;
}
.btnBefore span {
  color: #999999;
}
.btnAfter {
  /* background: url("../common/images/index/button.png"); */
}
.btnAfter span {
  color: #ffffff;
}
.btnOut {
  width: 100%;
  overflow: hidden;
  margin: 28px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/stockUniverse/gyzxz.vue